/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
// import { StyleSheet } from "react-native";

import Card from "@material-ui/core/Card";

interface ContainerCardProps {
  children?: React.ReactChild;
}

const loginStyle = {
  height: "100vh",
  // padding: 20,
  alignItems: "center",
  backgroundColor: "rgb(27, 31, 27, 0.8)",
  opacity: 0.9,
  borderRadius: 0,
};

export const ContainerCard = (props: ContainerCardProps) => {
  const { children } = props;
  return <Card style={loginStyle}>{children}</Card>;
};
